// src/utils/deepLinks.js
//
// Deep-link helpers for jumping straight to a captured request in the
// dashboard (MainApp, kept mounted outside <Routes> — see App.js
// RoutedContent). We deliberately DON'T use a `/request/:id` route: that
// would hide MainApp (its `display: onDashboard ? 'contents' : 'none'` guard
// keys off `pathname === '/'`) and tear down the live WebSocket. Instead a
// `?req=<requestId>` query param on `/` is parsed once by RoutedContent,
// handed to TrafficContext's `jumpTarget` channel, and then stripped so a
// later re-render doesn't re-jump.
//
// `requestId` here is the WP0 globally-unique row key
// (`${Date.now()}-${rand6}`, minted in proxyOnRequestHandler.js) — NOT the
// domain `id` (ad unit / correlator, often null/duplicated).

/**
 * Build a shareable/deep-linkable URL that jumps straight to `requestId` in
 * the dashboard. Returns null for a falsy requestId (nothing to link to).
 */
export function requestLink(requestId) {
  if (!requestId) return null;
  return `${window.location.origin}/?req=${encodeURIComponent(requestId)}`;
}

/**
 * Parse the `req` query param out of a location.search string (or any
 * '?...'-prefixed / bare query string). Returns the decoded value, or null
 * when absent/empty.
 */
export function parseReqParam(search) {
  try {
    const params = new URLSearchParams(search || '');
    const val = params.get('req');
    return val ? val : null;
  } catch {
    return null;
  }
}
